module.exports = __webpack_public_path__ + "img/aboutUs-header-img01.43fe4cc8.png";